import type {
  OAuthClientRegistrationRequest,
  OAuthClientRegistrationResponse,
} from './partner-token-exchange.types';
import API from '@/services/API.ts';
import { oauthEndpoints } from '@/services/API.constants.ts';

export const registerOAuthClient = async (
  _body: OAuthClientRegistrationRequest,
): Promise<OAuthClientRegistrationResponse> =>
  (
    await API.post<OAuthClientRegistrationResponse>(
      oauthEndpoints.clientRegistration,
      _body,
    )
  ).data;
